// extracted by mini-css-extract-plugin
export default {"modal":"_120TS","modalContent":"_3c0P9"};